<template>
  <div>
    <v-container fluid class="d-flex pa-0 fullHeight">
      <v-container fluid class="px-0 pt-0">

        <div class="px-md-10">
          <h4 class="primary--text mt-0" style="position: relative">
            {{ $t('modules.portalalumno.payments.paymentsStudents.view.labels.selectPayment') }}
          </h4>

          <ImageBanner
              v-if="showBannerMp"
              class="mt-6"
              :src="`images/portalalumno/theme/${this.$country}/payment/banner-mp${$vuetify.breakpoint.mdAndUp ? '' : '-mobile'}.jpg`"
              alt="Promocion Mercado Pago"
          ></ImageBanner>

          <div class="mt-10">
            <div class="pt-0 px-1" v-for="(paymentMethod, i) in orderedMethods" :key="`${paymentMethod.id}-${i}`">
              <div v-if="paymentMethod.id !== 'SUS' || showSubcription">
                <PaymentSelection
                :extraBenefit="extraBenefit"
                @paymentSelected="paymentSelected"
                :payment="paymentMethod"
                :validateExtraBenefit= "validateExtraBenefit"
                :validateExtraBenefitSemester = "validateExtraBenefitSemester"
              ></PaymentSelection>
              </div>
            </div>

            <div class="py-8 px-4 text-center" style="background-color: #efecec; border-radius: 5px;">
              <span class="body-1 font-weight-bold primary--text">{{ $t('modules.portalalumno.payments.paymentsStudents.view.labels.selectPaymentHelp') }}</span>
            </div>

            <div v-if="showBannerMp" class="terms_conditions">
              <p class="terms_conditions__title">{{ $t('modules.portalalumno.payments.paymentsStudents.view.banners.termsAndConditionsTitle') }}</p>
              <p class="terms_conditions__text" v-html="$t('modules.portalalumno.payments.paymentsStudents.view.banners.termsAndConditionsText')"></p>
            </div>
          </div>
        </div>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import PaymentSelection from '../Components/PaymentSelection/PaymentSelection'
import ImageBanner from '@/components/Banner/ImageBanner';

export default {
  components: {
    PaymentSelection,
    ImageBanner,
  },
  props: {
    isCheckoutPro: { type: Boolean, default: false },
    isGetnet: { type: Boolean, default: false },
    isUnired: { type: Boolean, default: false },
    isFintoc: { type: Boolean, default: false },
    isWibond: { type: Boolean, default: false },
    isGoCuotas: { type: Boolean, default: false },
    extraBenefit: Object,
    showSubcription: Boolean,
    validateExtraBenefit: Boolean,
    validateExtraBenefitSemester: Boolean,
  },

  data() {
    return {
      paymentMethods: [
        {
          id: 'GETNET',
          type: 'checkout',
          name: 'Getnet',
          icon: 'mdi-credit-card-multiple-outline',
          off: 0,
          order: 1,
        },{
          id: 'TC1',
          type: 'credit_card',
          color: 'green',
          name: 'Tarjeta de crédito',
          icon: 'mdi-credit-card-outline',
          description: '',
          off: 0,
          order: 2,
        }, {
          id: 'TC2',
          type: 'credit_card',
          color: 'green',
          name: '2 Tarjetas de crédito',
          icon: 'mdi-credit-card-multiple-outline',
          description: '',
          off: 0,
          order: 3,
        }, {
          id: 'TD',
          type: 'bank_transfer',
          color: 'green',
          name: 'Tarjeta de débito',
          icon: 'mdi-credit-card-outline',
          description: '',
          off: 0,
          order: 4,
        }, {
          id: 'FT',
          type: 'ticket',
          name: 'Efectivo',
          icon: 'mdi-cash-usd-outline',
          off: 0,
          order: 5,
        }, {
          id: 'ATM',
          type: 'atm',
          name: 'Pago de Servicios en Banca',
          icon: 'mdi-cash-usd-outline',
          off: 0,
          order: 6,
        }, {
          id: 'CHECK',
          type: 'checkout',
          name: 'Mercado Pago',
          icon: 'mdi-credit-card-multiple-outline',
          off: 0,
          order: 7,
        }, {
          id: 'FINTOC',
          type: 'checkout',
          name: 'Fintoc',
          icon: 'mdi-credit-card-multiple-outline',
          order: 8,
        }, {
          id: 'GOCUOTAS',
          type: 'checkout',
          name: 'Go cuotas',
          icon: 'mdi-credit-card-multiple-outline',
          off: 0,
          order: 10,
        }, {
          id: 'WIBOND',
          type: 'checkout',
          name: 'Wibond',
          icon: 'mdi-credit-card-multiple-outline',
          off: 0,
          order: 11,
        },{
          id: 'UNIRED',
          type: 'checkout',
          name: 'unired',
          icon: 'mdi-credit-card-multiple-outline',
          off: 0,
          order: 12,
        }
      ],
    };
  },
  computed: {
    enabledMethods() {
        let filteredMethods = this.isCheckoutPro ? this.paymentMethods : this.paymentMethods.filter(method => method.type !== 'checkout');
        if(!this.$isMexico) {
          filteredMethods = filteredMethods.filter(method => method.id !== 'ATM');
        }
        if(this.$isIPP) {
          filteredMethods = filteredMethods.filter(method => method.id !== 'FT');
        }
        if (!this.isFintoc) {
          filteredMethods = filteredMethods.filter(method => method.id !== 'FINTOC');
        }
        if (!this.isWibond) {
          filteredMethods = filteredMethods.filter(method => method.id !== 'WIBOND');
        }
        if (!this.isGoCuotas) {
          filteredMethods = filteredMethods.filter(method => method.id !== 'GOCUOTAS');
        }
        if (!this.isGetnet) {
          filteredMethods = filteredMethods.filter(method => method.id !== 'GETNET');
        }
        if (!this.isUnired) {
          filteredMethods = filteredMethods.filter(method => method.id !== 'UNIRED');
        }
        return filteredMethods;
      },
      orderedMethods() {
        const methods = [ ...this.enabledMethods ]
        const mercadopago = methods.find(method => method.id == 'CHECK')
        if (mercadopago) {
          if (this.showBannerMp) {
            mercadopago.order = 0
            mercadopago.off = 10
          }
        }
        methods.sort((a, b) => a.order - b.order)
        return methods
      },
      showBannerMp() {
        const now = new Date()
        const start = new Date('2025/02/18 12:00:00')
        const end = new Date('2025/03/14 12:00:00')
        return this.$isChile && start <= now && now < end
      }
  },
    methods: {
    paymentSelected(payment) {
      this.$emit('paymentSelected', payment);
      this.$trackEvent('Pagos', `Selección: ${payment.name}`, 'Método de pago')
    },
  },
};
</script>

<style scoped lang="scss">
  .terms_conditions {
    font-family: "DM Sans", "Roboto" !important;
    margin-top: 3em;

    &__title {
      font-size: 12px;
      margin-bottom: 0.75em;
      font-weight: 500;
    }
    &__text {
      font-size: 10px;
      opacity: 0.75;
      line-height: 1.2;
    }
  }
</style>
